import { Page } from "./page";

export class Blog extends Page
{
}
